export const singleCasementOptions = {

  configuration: [
    {
      id: 1,
      name: "N/A",
    },
  ],

  hinge: [
    {
      id: 1,
      name: "Right",
    },
    {
      id: 2,
      name: "Left",
    },
  ],

  bugscreen: [
    {
      id: 1,
      name: "Yes",
    },
  ],

  blind: [
    {
      id: 1,
      name: "N/A",
    },
    // {
    //   id: 2,
    //   name: "Solar Shade",
    // },
    // {
    //   id: 3,
    //   name: "Decorative Shade",
    // },
    // {
    //   id: 4,
    //   name: "Thermal Blind",
    // },
    {
      id: 5,
      name: "Solar Shade: Dove",
      internal: "solarshade_dove"
    },
    // {
    //   id: 6,
    //   name: "Solar Shade: Cocoa",
    //   internal: "solarshade_cocoa"
    // },
    // {
    //   id: 7,
    //   name: "Solar Shade: Charcoal",
    //   internal: "solarshade_charcoal"
    // },
    // {
    //   id: 8,
    //   name: "Solar Shade: Apricoat",
    //   internal: "solarshade_apricoat"
    // },
    // {
    //   id: 9,
    //   name: "Solar Shade: Linen",
    //   internal: "solarshade_linen"
    // },
    // {
    //   id: 10,
    //   name: "Solar Shade: Ash",
    //   internal: "solarshade_ash"
    // },
    {
      id: 11,
      name: "Thermal Blind: Cloud",
      internal: "thermalblind_cloud"
    },
    {
      id: 12,
      name: "Thermal Blind: Desert",
      internal: "thermalblind_desert"
    },
    {
      id: 13,
      name: "Thermal Blind: Slate",
      internal: "thermalblind_slate"
    },
    {
      id: 14,
      name: "Thermal Blind: Raven",
      internal: "thermalblind_raven"
    },
  ],

  blindDrirection: [
    {
      
      id: 1,
      name: "N/A",
    },
    // {
    //   name: "Yes",
    // },
    // {
    //   name: "No",
    // },
    {
      id: 2,
      name: "Top Down",
    },
    {
      id: 3,
      name: "Bottom Up",
    },
  ],

  paintColor: [
    {
      id: 1,
      name: "Standard (White)",
      internal: "white paint",
      color: 0xffffff,
    },
    {
      id: 2,
      name: "Gray",
      internal: "gray paint",
      color: 0x444444,
    },
    {
      id: 3,
      name: "Brass",
      internal: "brass paint",
      color: 0xe1c16e,
    },
  ],

  paintedSide: [
    {
      id: 1,
      name: "N/A",
    },
    {
      id: 2,
      name: "Interior",
    },
    {
      id: 3,
      name: "Exterior",
    },
  ],

  premiumCenterLock: [
    {
      id: 1,
      name: "Yes",
    },
    {
      id: 2,
      name: "No",
    },
  ],

  hardware: [
    {
      id: 1,
      name: "Standard White",
      internal: "white paint",
    },
    {
      id: 2,
      name: "Black",
      internal: "black paint",
    },
    {
      id: 3,
      name: "Satin Nickel",
      internal: "satin nickel",
    },
    // {
    //   id: 4,
    //   name: "Painted",
    //   internal: "painted",
    // },
  ],

  frostedGlass: [
    {
      id: 1,
      name: "N/A",
    },
    {
      id: 2,
      name: "Delta Frost",
    },
    {
      id: 3,
      name: "Flemish",
    },
    {
      id: 4,
      name: "Frosted",
    },
    {
      id: 5,
      name: "Glue Chip",
    },
    {
      id: 6,
      name: "Silvet",
    },
    {
      id: 7,
      name: "Acid",
    },
  ],

  grillStyle: [
    {
      id: 1,
      name: "N/A",
    },
    {
      id: 2,
      name: "Gold Pewter",
    },
    {
      id: 3,
      name: "Silver Pewter",
    },
    {
      id: 4,
      name: "White Pewter",
    },
    {
      id: 5,
      name: "Flat Grill",
    },
    {
      id: 6,
      name: "Beveled Grill",
    },
    {
      id: 7,
      name: "Beveled",
    },
  ],

  grillPatern: [
    {
      id: 1,
      name: "N/A",
    },
    {
      id: 2,
      name: "Victorian",
    },
    {
      id: 3,
      name: "Colonial",
    },
    {
      id: 4,
      name: "Marginal",
    },
    {
      id: 5,
      name: "SH Look",
    },
  ],

  SDLStyle: [
    {
      id: 1,
      name: "N/A",
    },
    {
      id: 2,
      name: "Flat",
    },
    {
      id: 3,
      name: "Beveled",
    },
  ],

  SDLPatern: [
    {
      id: 1,
      name: "N/A",
    },
    {
      id: 2,
      name: "Victorian",
    },
    {
      id: 3,
      name: "Colonial",
    },
    {
      id: 4,
      name: "Marginal",
    },
    {
      id: 5,
      name: "SH Look",
    },
  ],

  extraScreenBlindCartirdge: [
    {
      id: 1,
      name: "Yes",
    },
    {
      id: 2,
      name: "No",
    },
  ],

  limiter: [
    {
      id: 1,
      name: "Yes",
    },
    {
      id: 2,
      name: "No",
    },
  ],

  nightLock: [
    {
      id: 1,
      name: "N/A",
    },
  ],
};
